import { render, staticRenderFns } from "./WapMy.vue?vue&type=template&id=2a67cc1b&scoped=true&"
import script from "./WapMy.vue?vue&type=script&lang=js&"
export * from "./WapMy.vue?vue&type=script&lang=js&"
import style0 from "./WapMy.vue?vue&type=style&index=0&id=2a67cc1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67cc1b",
  null
  
)

export default component.exports